import * as React from "react";
import Container from "@mui/material/Container";
import { UserDetails } from "./UserDetails";
import LabelImportantOutlinedIcon from "@mui/icons-material/LabelImportantOutlined";
import { GenericMessage } from "../components/util/GenericMessage";
import { Outlet } from "react-router-dom";
import { Navbar } from "./Navbar";
import { BreadcrumbBar } from "./Breadcrumbs";

const Header = () => {
  /********Website header noftifaction mgs*********/
  const headMessage = {
    display: false, //needs to be true to show downtime message
    message:
      "Briefly unavailable for scheduled maintenance please check back in a minute",
  };

  return (
    <>
      <GenericMessage data={headMessage} />
      <Container maxWidth={false} className="header" sx={{ maxWidth: '100vw', width: '100%', left: 0,zIndex: 1000 }}>
        <div className="head-warp">
          <div className="logo"></div>
          <span className="app-heading">
            <LabelImportantOutlinedIcon
              fontSize="medium"
              sx={{ margin: "0px 8px", fontSize: "1.8rem" }}
            />
            Lease Abstraction Tracker
          </span>
        </div>
        <UserDetails />
      </Container>
      <Navbar/>
      <BreadcrumbBar/>
      <div >
      <Outlet />
      </div>
    </>
  );
};

export default Header;
